import React from "react";
import { CTAButton } from "@/components/primitives";

export default function NotFound() {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-navy grain text-center">
      <div className="pointer-events-none absolute -top-20 left-1/3 h-80 w-80 rounded-full bg-emerald2/20 blur-[120px]" />
      <div className="relative px-6">
        <p className="font-display text-7xl font-semibold text-emerald-300 sm:text-9xl">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-white sm:text-3xl">This page took a different route.</h1>
        <p className="mt-3 text-slate-400">The page you're looking for isn't here — but the forum still is.</p>
        <CTAButton to="/" className="mt-8">Back to home</CTAButton>
      </div>
    </section>
  );
}
